export default __webpack_public_path__ + "static/media/Aura-Egg__12.ef9fe0a3.png";